export default __webpack_public_path__ + "static/media/AddPhoto.3d443979.svg";